import cn from 'classnames';
import parse from 'html-react-parser';
import { FC } from 'react';

import { IconMap, IconName } from '@/shared/constants/icons';
import {
  getCleanInput,
  isBuilderStringPresent,
  SanitizeMode,
} from '@/shared/text';
import { BuilderString } from '@/shared/types';

import styles from './ListItemLeading.module.scss';

interface Props {
  number?: BuilderString;
  icon?: IconName;
  locale: string;
}

export const ListItemLeading: FC<Props> = ({ icon, number, locale }) => {
  if (icon && IconMap[icon]) {
    const Icon = IconMap[icon];
    return <Icon className={cn(styles.icon, 'u-color-secondary')} />;
  }

  if (isBuilderStringPresent(number, locale)) {
    return (
      <span className={cn(styles.number, 'u-color-brand')}>
        {parse(getCleanInput(locale, SanitizeMode.SINGLE_LINE, number))}
      </span>
    );
  }

  return null;
};
